'use client';

/**
 * SysObeyaExplorerCohesionCard — explorer report-picker for
 * `sel:cohesion` (Procedural Patterns).
 *
 * Click row → dispatches `setExplorerSelection('cohesion')` → canvas
 * routes to the `mode9_cohesion` preset. Kebab → Copy report /
 * Download capture (role-gated), all inherited from ReportTile.
 *
 * Calls `useSystemObeyaView('cohesion')` for chrome labels — shares
 * the React Query cache entry with the canvas cards once the
 * selection is active; the same query is what the capture envelope
 * picks up.
 *
 * @see klyde_edge/ui_config/composition/cards/system_obeya.py — content_key="sys_obeya_explorer_cohesion"
 * @see klyde_edge/ui_config/labels/system_obeya.py — sel_cohesion_*
 */

import { Boxes } from 'lucide-react';
import { useSystemObeyaView } from '@/components/canvas/cards/system_obeya/use-system-obeya-view';
import { ReportTile } from './report-tile';

const VIEW_NAME = 'cohesion';

export function SysObeyaExplorerCohesionCard() {
  const { data } = useSystemObeyaView(VIEW_NAME);
  const L = data?.labels ?? {};

  return (
    <ReportTile
      selection={VIEW_NAME}
      label={L.sel_cohesion_label ?? ''}
      description={L.sel_cohesion_description}
      Icon={Boxes}
      copyReportLabel={L.action_copy_report}
      downloadCaptureLabel={L.action_download_capture}
      menuLabel={L.report_menu_label}
      mode="mode9"
      contentKey="sys_obeya_explorer_cohesion"
    />
  );
}
